(() => {
  /** Jenny's story switches between the founder profile and her product vision. */
  const initJenny = (root, signal) => {
    const section = root.querySelector('[data-jenny-carousel]');
    const nextButton = section?.querySelector('[data-jenny-next]');
    const previousButton = section?.querySelector('[data-jenny-previous]');
    const profile = section?.querySelector('.about-jenny__row');
    const insights = section?.querySelector('.about-jenny__insights');
    if (!section || !nextButton || !previousButton) return;

    const showInsights = (visible, moveFocus = true) => {
      section.classList.toggle('is-insights', visible);
      nextButton.setAttribute('aria-pressed', String(visible));
      profile?.setAttribute('aria-hidden', String(visible));
      insights?.setAttribute('aria-hidden', String(!visible));
      if (moveFocus) (visible ? previousButton : nextButton).focus();
    };

    nextButton.addEventListener('click', () => showInsights(true), { signal });
    previousButton.addEventListener('click', () => showInsights(false), { signal });
    showInsights(false, false);
  };

  /** What We Build is a three-card carousel with a centered active card. */
  const initBuildCarousel = (root, signal) => {
    const carousel = root.querySelector('[data-build-carousel]');
    if (!carousel) return;

    const cards = [...carousel.querySelectorAll('[data-build-card]')]
      .sort((first, second) => Number(first.dataset.buildOrder) - Number(second.dataset.buildOrder));
    const previousButton = carousel.querySelector('[data-build-previous]');
    const nextButton = carousel.querySelector('[data-build-next]');
    if (cards.length < 2 || !previousButton || !nextButton) return;

    let activeIndex = Math.min(1, cards.length - 1);
    const update = () => {
      cards.forEach((card, index) => {
        const offset = index - activeIndex;
        card.style.left = `${50 + offset * 50.4226042}%`;
        card.classList.toggle('is-active', offset === 0);
        card.classList.toggle('is-previous', offset === -1);
        card.classList.toggle('is-next', offset === 1);
        card.classList.toggle('is-hidden', Math.abs(offset) > 1);
        card.setAttribute('aria-hidden', String(index !== activeIndex));
      });
      previousButton.disabled = activeIndex === 0;
      nextButton.disabled = activeIndex === cards.length - 1;
    };

    previousButton.addEventListener('click', () => {
      if (activeIndex === 0) return;
      activeIndex -= 1;
      update();
    }, { signal });
    nextButton.addEventListener('click', () => {
      if (activeIndex === cards.length - 1) return;
      activeIndex += 1;
      update();
    }, { signal });
    update();
  };

  /** Lifecycle-safe component for Shopify's live theme editor. */
  class BeamboxAbout extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      initJenny(this, this.abortController.signal);
      initBuildCarousel(this, this.abortController.signal);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
  }

  if (!customElements.get('beambox-about')) {
    customElements.define('beambox-about', BeamboxAbout);
  }
})();
